<template>
  <section id="comments">
    <div>
      <main>
        <div v-html="commentGuidelines"></div>
        <h3>{{ comments.length}} {{ comments.length === 1 ? 'Comment' : 'Comments' }}</h3>
        <comment-form :postId="postId"></comment-form>
        <div class="comments" ref="comments">
          <comment v-if="!expanded && firstComment" :comment="firstComment" :postId="postId"></comment>
          <comment v-if="expanded" v-for="(comment, index) in rootComments" :comment="comment" :key="index" :postId="postId" :childComments="childComments"></comment>
        </div>
        <p class="has-text-centered"><button v-if="comments.length > 1" @click="toggleExpand" class="button is-primary">{{ expanded ? 'Show Less' : 'Load All Comments' }}</button></p>
      </main>
      <aside></aside>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Comment from './Comment'
import CommentForm from './CommentForm'

export default {
  name: 'comments',
  props: ['comments', 'postId'],
  data () {
    return {
      expanded: false
    }
  },
  components: {
    CommentForm,
    Comment
  },
  methods: {
    toggleExpand () {
      this.expanded = !this.expanded
      this.$refs.comments.scrollIntoView()
    }
  },
  computed: {
    commentGuidelines () {
      if (this.siteInfo && this.siteInfo.commentGuidelines) return this.siteInfo.commentGuidelines
    },
    firstComment () {
      if (this.rootComments) return this.rootComments[0]
    },
    rootComments () {
      if (this.comments) {
        return this.comments.filter((comment) => {
          return comment.parent === '0'
        })
      }
    },
    childComments () {
      if (this.comments) {
        return this.comments.filter((comment) => {
          return comment.parent !== '0'
        })
      }
    },
    ...mapGetters([
      'siteInfo'
    ])
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

h3
  font-weight: bold

#comments
  padding: 0
  background: transparent

.button.is-primary
  color: $textColor
  font-weight: bold
  text-transform: uppercase
  margin-top: 30px
  padding-left: 1.5em
  padding-right: 1.5em
</style>



// WEBPACK FOOTER //
// Comments.vue?259480ad